<template>
  <div class="smsSend">
    <el-row>
      <el-col :span="14">
        <div class="grid-content bg-purple">
          <el-row>
            <el-col :span="8">
              <span style="font-size: 14px">
                当前选择
                <span style="font-size: 20px; color: red">{{
                  memberList.length
                }}</span>
                位会员</span
              >
            </el-col>
            <el-col :span="4" :offset="12">
              <el-popover placement="bottom" width="300" trigger="click">
                <member-list
                  :memberList="memberList"
                  @selectMember="selectMember"
                  @unSelectMember="handleClose"
                ></member-list>
                <el-button slot="reference" type="primary" size="mini" plain
                  >选择会员</el-button
                >
              </el-popover>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div
                style="
                  height: 150px;
                  padding: 5px 10px 5px 10px;
                  overflow-y: auto;
                  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                "
              >
                <el-tag
                  v-for="member in memberList"
                  :key="member.id"
                  effect="plain"
                  :disable-transitions="false"
                  closable
                  @close="handleClose(member)"
                  >{{ member.name }}</el-tag
                >
              </div>
              <br />
              <el-switch
                v-model="all"
                active-text="全部用户"
                @change="selectAll"
              >
              </el-switch>
            </el-col>
          </el-row>
          <el-divider><i class="el-icon-mobile-phone"></i></el-divider>
          <el-row>
            <el-col :span="8">
              <span style="font-size: 14px"
                >您当前输入
                <span style="font-size: 20px; color: red">{{ words }}</span>
                个字</span
              >
              <el-popover
                placement="right"
                title="提示"
                width="200"
                trigger="hover"
              >
                <p style="font-size: 12px">
                  1. 70个字（包含70）以内按一条计费，超过70字每条以67个字计费。
                </p>
                <p style="font-size: 12px">
                  2. 当前数据仅做参考，具体数据请以实际短信内容为准。
                </p>
                <i
                  class="el-icon-warning"
                  style="color: #67c23a"
                  slot="reference"
                ></i> </el-popover
            ></el-col>
            <el-col :span="4" :offset="12">
              <el-popover placement="bottom" width="300" trigger="click">
                <sms-template-list @selectTemplate="selectTemplate">
                </sms-template-list>
                <el-button slot="reference" type="primary" size="mini" plain
                  >选择模板</el-button
                >
              </el-popover>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-input
                type="textarea"
                :rows="9"
                class="resizeNone"
                v-model="content"
                readonly
              ></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="text-align: right">
              <el-date-picker
                v-model="sendTime"
                type="datetime"
                :editable="false"
                default-time="13:00:00"
                size="mini"
                placeholder="选择日期时间"
              >
              </el-date-picker>
              <el-button
                type="primary"
                size="mini"
                @click="sendMsg"
                plain
                :loading="sendBtn"
                >保存任务</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="9" :offset="1">
        <div id="phoneOut">
          <div id="phoneIn">
            <div id="phoneReception">
              <span id="lefttime" v-if="timeShow">{{ time }}</span
              ><br />
              <span id="left" v-if="timeShow">{{ content }}</span>
            </div>
            <div id="phoneOperation">
              <input id="phoneText" type="text" size="30px" />
              <input id="phoneSend" type="button" value="发送" />
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { findMemberList, addTask } from "@/api/index";
import MemberList from "../member/MemberList.vue";
import SmsTemplateList from "./SmsTemplateList.vue";

export default {
  components: {
    MemberList,
    SmsTemplateList,
  },
  data() {
    return {
      count: 0,
      words: 0,
      all: false,
      templateId: null,
      content: "",
      time: "",
      timeShow: false,
      memberDialog: {
        show: true,
      },
      memberList: [],
      sendTime: "",
      sendBtn: false,
    };
  },
  methods: {
    selectMember(data) {
      this.all = false;
      this.memberList.push(data);
    },
    handleClose(data) {
      this.all = false;
      let index = this.memberList.findIndex((item) => item.id === data.id);
      this.memberList.splice(index, 1);
    },
    selectAll(value) {
      if (value) {
        findMemberList().then((res) => {
          if (res.success == true) {
            this.memberList = res.result;
          } else {
            this.$notify.error({
              title: "错误",
              message: res.message,
            });
          }
        });
      } else {
        this.memberList = [];
      }
    },
    selectTemplate(template) {
      this.templateId = template.id;
      this.content = template.templateContent;
    },
    sendMsg() {
      if (this.memberList.length == 0) {
        this.$message.error("至少选择一位会员进行发送");
        return;
      }
      if (this.templateId == null || this.templateId == "") {
        this.$message.error("请选择短信模板");
        return;
      }
      if (this.sendTime == null || this.sendTime == "") {
        this.$message.error("请选择发送时间");
        return;
      }
      this.sendBtn = true;
      addTask({
        id: this.templateId,
        memberList: this.memberList,
        sendTime: this.sendTime,
      }).then((res) => {
        if (res.success == true) {
          this.$message({
            message: "保存成功，等候发送。",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
        this.sendBtn = false;
      });
    },
  },
  watch: {
    content: function (newValue, oldValue) {
      this.words = Array.from(newValue).length;
      if (this.words > 0 && this.timeShow == false) {
        var time = new Date();
        this.time = time.toLocaleString();
        this.timeShow = true;
      } else if (this.words == 0 && this.timeShow == true) {
        this.timeShow = false;
      }
    },
  }
};
</script>

<style lang="scss">
.smsSend {
  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .el-row {
    height: 100%;
    margin-bottom: 5px;
  }

  .el-col {
    height: 100%;
  }

  .bg-sms {
    height: 500px;
    background: url("../../assets/sms-bg.png") no-repeat center 0px;
    background-position: center 0px;
    background-size: 93%;
  }

  .sms_content {
    background-color: chartreuse;
    border: rgba(0, 0, 0, 0.12);
    border-radius: 5px;
    position: relative;
    top: 80px;
    left: 37px;
    width: 235px;
  }
  .resizeNone {
    .el-textarea__inner {
      //el_input中的隐藏属性
      resize: none; //主要是这个样式
    }
  }

  #phoneOut {
    width: 320px;
    height: 500px;
    border: 1px solid #333;
    border-radius: 10px;
    margin-left: 30px;
  }
  #phoneIn {
    width: 300px;
    height: 470px;
    border: 1px solid yellow;
    margin: 0 auto;
    margin-top: 20px;
    border-radius: 10px;
  }
  #phoneReception {
    margin-top: 15px;
    padding-left: 10px;
    padding-right: 10px;
    width: 300px;
    height: 400px;
    border-radius: 10px;
  }
  #phoneOperation {
    width: 295px;
    height: 40px;
    margin: 0 auto;
    border: 1px solid #a9a9a9;
    position: relative;
  }
  img {
    width: 30px;
    height: 28px;
  }
  #phoneSend {
    width: 50px;
    height: 30px;
    position: absolute;
    margin-top: 5px;
    margin-left: 240px;
  }
  #phoneText {
    position: absolute;
    margin-top: 5px;
    margin-left: 10px;
    padding: 5px;
  }
  #lefttime {
    font-size: 3px;
  }
  #left {
    background-color: green;
    color: #fff;
    float: left;
    border-radius: 3px;
    word-break: normal;
    width: 55%;
    display: block;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow: hidden;
    font-size: 10px;
    padding: 5px;
  }
}
</style>